import { j as e } from "../../../../_virtual/jsx-runtime.js";
import { cn as u } from "../../../../lib/utils.js";
const n = ({ data: s, className: i }) => {
  const p = `${100 / s.length}%`;
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: u("absolute left-0 right-0", i),
      style: {
        margin: "0 auto",
        width: "85%",
        height: "10px"
      },
      children: s.map(({ sleep: h, rem: m }, t) => {
        const o = Number(h), l = Number(m), r = o + l || 0, a = o / r * 100 || 0, d = l / r * 100 || 0;
        return /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "absolute h-full flex",
            style: {
              left: `${t * 100 / s.length}%`,
              width: p,
              margin: "0 auto",
              display: "flex"
            },
            children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: "bottom-0 left-0 h-full",
                  style: {
                    backgroundColor: "rgba(144, 238, 144, 0.3)",
                    width: `${a}%`,
                    height: "10px",
                    borderTopLeftRadius: t === 0 ? "5px" : "0px",
                    borderBottomLeftRadius: t === 0 ? "5px" : "0px"
                  }
                }
              ),
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: "bottom-0 left-0 h-full",
                  style: {
                    backgroundColor: "rgba(34, 139, 34, 0.5)",
                    width: `${d}%`,
                    height: "10px",
                    left: `${a}%`,
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px"
                  }
                }
              )
            ]
          },
          `sleep-${t}`
        );
      })
    }
  );
};
export {
  n as default
};
